<template>
    <div class="input-group password-input-group">
        <input 
            aria-label="Password" 
            aria-describedby="password-toggle-label"
            ref="password" 
            :type="visible ? 'text' : 'password'"
            :class="['form-control', 'password-input', { 'is-invalid': hasError }]" 
            :name="name"
            :placeholder="placeholder"
            :required="required"
            :autocomplete="autocomplete"
            :disabled="disabled"
            v-model="internalValue"
            @change="$emit('change', $event)">

        <button 
            type="button"
            class="input-group-text pe-4 border-0 bg-transparent" 
            :class="{ 'is-visible': visible, 'disabled': disabled }"
            :aria-label="visible ? 'Hide password' : 'Show password'"
            :aria-pressed="visible"
            id="password-toggle-label"
            :disabled="disabled"
            @click="toggleVisibility"
            @keydown.enter.prevent="toggleVisibility"
            @keydown.space.prevent="toggleVisibility">
            <span class="pw-icon">
                <transition name="fade-scale">
                    <img v-if="!visible" key="lock" class="pw-icon-img" src="/img/icons/avid-icons/lock.svg" alt="">
                </transition>
                <transition name="fade-scale">
                    <img v-if="visible" key="unlock" class="pw-icon-img" src="/img/icons/avid-icons/unlock.svg" alt="">
                </transition>
            </span>
        </button>

        <span v-if="hasError && showInlineError" class="invalid-feedback" role="alert">
            <strong>{{ errorMessage }}</strong>
        </span>
    </div>
    
</template>

<script>
    export default {
        props: {
            hasError: {
                type: Boolean,
                default: false
            },
            errorMessage: {
                type: String,
                default: ''
            },
            modelValue: {
                type: [String, Number],
                default: ''
            },
            name: {
                type: String,
                default: 'password'
            },
            placeholder: {
                type: String,
                default: 'Password'
            },
            required: {
                type: Boolean,
                default: true
            },
            autocomplete: {
                type: String,
                default: 'current-password'
            },
            showInlineError: {
                type: Boolean,
                default: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        emits: ['update:modelValue', 'change'],
        data() {
            return {
                visible: false,
                internalValue: this.modelValue
            }
        },
        watch: {
            modelValue(newVal) {
                // Keep internal value in sync if parent controls it
                this.internalValue = newVal;
            },
            internalValue(newVal) {
                // Emit updates so v-model on parent stays in sync when used
                this.$emit('update:modelValue', newVal);
            }
        },
        methods: {
            toggleVisibility() {
                if (this.disabled) return;
                const input = this.$refs.password;
                if (!input) return;
                this.visible = !this.visible;
            }
        }
    }
</script>